import { Outlet } from "react-router-dom";

const CategoryLayout = () => {
  return <Outlet />;
};
export default CategoryLayout;
